import React, { useEffect, useState } from "react";
import { Divide as Hamburger } from "hamburger-react";
import Humburger from "./Humburger";
import { Link } from "react-router-dom";
import { FaMobileAlt } from "react-icons/fa";
import { AiFillSchedule } from "react-icons/ai";
import mainLogo from "../../../Assets/main_logo.jpg";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  });
  return (
    <div
      className={`${
        sticky
          ? "sticky smooth duration-500 "
          : "shadow-2xl md:px-5 px-3 py-3 md:py-0 bg-white absolute top-0 left-0 right-0 z-10  text-gray-700 border-gray-200 border-none rounded-none"
      }`}
    >
      <nav class="relative">
        <div class="flex md:flex-wrap items-center justify-between  relative py-2 md:px-10 px-2">
          {/* Hamburger Menu */}
          <div>
            <span
              className="material-icons menu-btn"
              onClick={() => setIsOpen(true)}
            >
              {" "}
              <Hamburger toggled={isOpen} toggle={setIsOpen} />
            </span>
            <Humburger isOpen={isOpen} onChange={setIsOpen}></Humburger>
          </div>

          <div>
            <div
              className={`${
                sticky
                  ? "hidden smooth duration-500 "
                  : "md:w-[120px] w-[85px] absolute left-[50%] right-0 rounded-b-lg middle-logo top-8 md:top-12 smooth duration-500 "
              }`}
            >
              <div className="md:block hidden">
                <Link to="/" className="hover:no-underline">
                  <img
                    src={mainLogo}
                    alt="Matir Maya Eco Resort"
                    className="rounded-b-lg"
                  />
                </Link>
              </div>
              <div className="block md:hidden">
                <Link to="/" className="hover:no-underline">
                  <img
                    src="https://i.ibb.co/fG8Gg9W/matirmaya-logo.png"
                    alt="Matir Maya Eco Resort"
                    className="rounded-b-lg"
                  />
                </Link>
              </div>
            </div>
            <div
              className={`${
                sticky
                  ? "w-[90px] absolute left-[50%] right-0 rounded-b-lg middle-logo"
                  : "w-[120px] hidden "
              }`}
            >
              <div>
                <Link to="/" className="hover:no-underline">
                  <img
                    src="https://i.ibb.co/fG8Gg9W/matirmaya-logo.png"
                    alt="Matir Maya Eco Resort"
                    className="rounded-b-lg"
                  />
                </Link>
              </div>
            </div>
          </div>

          {/* Booking & Mobile Number */}
          <div className="">
            <div className="py-1 flex">
              <p className="flex flex-col md:flex-row items-center md:gap-2 hover:-translate-y-1 duration-300">
                <FaMobileAlt />
                <a href="tel:01867-877677">
                  <span className="text-center text-base md:font-bold text-[13px] md:text-[16px]">
                    01867 877 677
                  </span>
                </a>
              </p>
              <Link
                to="/Online_Booking"
                class="relative hover:no-underline px-5 overflow-hidden font-bold text-[#bb4f32] group md:block hidden"
              >
                <p className="flex items-center gap-2 hover:-translate-y-1 duration-300 ">
                  <AiFillSchedule />
                  <span class="relative transition-colors duration-300 delay-200 group-hover:text-blue-900 ease text-base">
                    Book Online
                  </span>
                </p>
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
